import type { ColumnsType } from 'antd/es/table';
import { Button, Switch, Tooltip } from 'antd';
import { SettingOutlined, FolderOpenOutlined } from '@ant-design/icons';
import type { Board } from '../../hooks/useBoards';
import { getBoardHeaderInfo } from '../boardHeaderStructure';

export const getBoardColumnsWithActions = (
    { onManageRoles, onManageConferenceRoles, onTogglePermission, isHumintecUser }: { 
        onManageRoles: (board: Board) => void; 
        onManageConferenceRoles: (board: Board) => void;
        onTogglePermission: (board: Board, checked: boolean) => void;
        isHumintecUser: boolean;
    }
): ColumnsType<Board> => [
    {
        title: 'ID',
        dataIndex: 'board_id',
        key: 'board_id',
        hidden: true,
    },
    {
        title: '게시판',
        dataIndex: 'name',
        key: 'name',
        render: (name: string, record: Board) => {
            // 상위 그룹(회원공간 등) 행: 펼침 구조의 부모로 표시
            if (record.isGroup) {
                return (
                    <span style={{ fontWeight: 700, display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                        <FolderOpenOutlined style={{ color: '#1677ff' }} />
                        {name}
                    </span>
                );
            }
            const info = getBoardHeaderInfo(name);
            return <span style={{ fontWeight: 600 }}>{info.label}</span>;
        },
    },
    ...(isHumintecUser ? [{
        title: <Tooltip title='스위치 on &rarr; 카테고리 별로 권한 부여 / 스위치 off &rarr; 게시판 전체에 대한 권한 부여' placement='top'>카테고리 별 권한</Tooltip>,
        dataIndex: 'isCategoryPermissionEnabled',
        key: 'isCategoryPermissionEnabled',
        align: 'center' as const,
        width: 150,
        render: (text: any, record: Board) => {
            if (record.isPermissionEnabled) {
                return (
                    <Switch 
                        checked={record.isCategoryPermissionEnabled}
                        onChange={(checked) => onTogglePermission(record, checked)}
                    />
                );
            }
        },
    }] : []),
    {
        title: '',
        key: 'action',
        align: 'center',
        width: 180,
        fixed: 'right',
        render: (_, record) => {
            if (record.isPermissionEnabled && !record.isCategoryPermissionEnabled) {
                return (
                    <Button
                        type="primary"
                        icon={<SettingOutlined />}
                        onClick={() => onManageConferenceRoles(record)}
                    >
                        관리
                    </Button>
                );
            }
            else if (record.isPermissionEnabled && record.isCategoryPermissionEnabled) {
                return (
                    <Button
                        type="primary"
                        icon={<SettingOutlined />}
                        onClick={() => onManageRoles(record)}
                    >
                        관리
                    </Button>
                );
            }
            return null;
        },
    },
];
